import Regimens from '../../../../components/Regimens'
import { MentalRegimensProps } from '../utils/types'

export const MentalRegimens = ({ lists }: MentalRegimensProps) => {
  return (
    <Regimens
      recordLabel='Mind Strategy'
      durationEnabled
      frequencyEnabled
      lists={lists}
    />
  )
}
